import React, {useEffect, useRef, useState} from "react";
import {fetchNews} from "../api";

const TrendingNewsScroller = () => {
  const [news, setNews] = useState([]);
  const [isPaused, setIsPaused] = useState(false);
  const scrollerRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  // Fetch news from the API
  useEffect(() => {
          fetchNews()
      .then(data => {
          console.log('News',data);
          const news = JSON.parse(data)
          setNews(news);
          console.log('News',news);
      })
      }, []);
 useEffect(() => {
    let animationFrameId;

    const scrollContent = () => {
      if (!isPaused && scrollerRef.current) {
        setScrollPosition((prev) => {
          const newScrollPosition = prev - 1;
          const scrollWidth = scrollerRef.current.scrollWidth;
          const containerWidth = scrollerRef.current.offsetWidth;

          // Reset scroll when it reaches the end
          return Math.abs(newScrollPosition) >= scrollWidth - containerWidth
            ? 0
            : newScrollPosition;
        });
      }
      animationFrameId = requestAnimationFrame(scrollContent);
    };

    scrollContent();

    return () => cancelAnimationFrame(animationFrameId);
  }, [isPaused]);

  // Styles
  const styles = {
    container: {
      position: "relative",
      overflow: "hidden",
      backgroundColor: "#f5f5f5",
      border: "1px solid #e0e0e0",
      borderRadius: "8px",
      padding: "8px 0",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      width: "100%",
    },
    scroller: {
      display: "flex",
      transform: `translateX(${scrollPosition}px)`,
      whiteSpace: "nowrap",
      transition: isPaused ? "none" : "transform 0.1s linear",
    },
    newsItem: {
      display: "inline-block",
      padding: "0 16px",
      fontSize: "1rem",
      color: "#007bff",
      fontWeight: "bold",
      textDecoration: "none",
      cursor: "pointer",
    },
  };


  return (
    <div style={styles.container}
                  onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
    >
      {/*<style>{styles.marqueeKeyframes}</style>*/}
      <div style={styles.scroller} ref={scrollerRef}>

                    {(news != null) ?
                    Object.keys(news).map((key) => (
                        (["Markets","Economy","Business","Results","Top News"].includes(key)) ?
          news[key].map((item, index) => (
            // <span style={styles.newsItem} key={index}>{item[1]}</span>
            <a
              href={item[3]}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.newsItem}
              key={index}
              title={item[1]}
            >
              {item[1]}
            </a>
          )) : ""
        )) : (
          <span style={styles.newsItem}>Loading news...</span>
        )}
      </div>
    </div>
  );
};
export default TrendingNewsScroller;